const Icon360: React.FC = () => {
	return (
		<svg
			width="84"
			height="84"
			viewBox="0 0 84 84"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M41.0623 50.5146L41.0688 46.3509C43.4735 48.1201 47.5763 50.969 47.5763 50.969L50.5049 52.9974L50.5768 53.1123C50.5768 53.1123 44.5758 58.256 41.0688 61.2565L41.0656 56.6109C36.9015 56.5392 32.6461 55.9495 28.6938 54.6331C24.9826 53.3982 19.9843 50.873 18.4659 47.0314C18.3356 46.6991 18 45.6955 18 45.386V39.4819L18.3877 40.7755C19.9615 45.0471 25.7222 47.6994 29.8081 48.905C33.4216 49.9704 37.299 50.4983 41.0688 50.5081L41.0623 50.5146Z"
				fill="#0B75E1"
			/>
			<path
				d="M43.8116 23L43.6375 27.8395C47.668 27.934 51.8159 28.5107 55.6444 29.7912C61.1151 31.6224 68.3909 35.9006 65.3378 42.7756C63.738 39.6835 60.5351 37.6861 57.3973 36.4056C53.0833 34.6429 48.2871 33.8674 43.6375 33.7827V38.2237C40.7572 36.1156 36.2726 32.8588 34.0972 31.4367C34.7391 30.759 36.6695 28.8103 37.8379 27.8395C38.2665 27.4833 41.4163 24.7146 43.8116 23Z"
				fill="#0B75E1"
			/>
			<path
				d="M66.0388 45.3922C65.726 48.4941 62.5296 51.2148 59.9914 52.6387C59.5385 52.8928 57.9484 53.6455 57.5542 53.7986C55.622 54.548 54.0743 55.0498 54.0743 55.0498C54.0743 55.0498 54.0189 54.2939 53.9961 53.2512L54.0841 48.96C58.385 47.5948 63.1096 45.5942 65.3709 41.4399L66.0356 39.4849V45.3889L66.0388 45.3922Z"
				fill="#0B75E1"
			/>
			<path
				d="M29.468 35.2654C25.3234 36.5557 20.8334 38.6052 18.7155 42.6162C17.0896 38.9929 18.3604 35.8356 21.257 33.4277C23.6193 31.463 26.5615 30.2411 29.468 29.3223V35.2654Z"
				fill="#0B75E1"
			/>
		</svg>
	)
}

export default Icon360
